/**
 * DevExtreme (esm/__internal/ui/text_box/m_text_editor.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import registerComponent from "../../../core/component_registrator";
import TextEditorMask from "./m_text_editor.mask";
registerComponent("dxTextEditor", TextEditorMask);
export default TextEditorMask;
